import React, { useState, useEffect } from "react";

import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { Grid } from "@material-ui/core";
import { useSnackbar } from "notistack";

import { getById } from "../../../services/formulario/FormularioService";

import FormHeader from "../../../components/shared/form/formHeader";
import ContainerDragAndDrop from "../../../components/formularios/dragAndDrop/containerDragAndDrop";

const EditarFormulario = (props) => {
  const { enqueueSnackbar } = useSnackbar();
  const { history } = props;

  const id = props.match.params.id ? props.match.params.id : null;

  const tituloPagina = "Editar Formulário";
  const [dadosFormularioEditar, setDadosFormularioEditar] = useState(null);

  useEffect(() => {
    const getDadosFormularioEditar = async (id) => {
      try {
        await getById(id).then((response) => {
          if (response && response.status === 200) {
            const { data } = response;
            let newData = data;
            newData.campos.sort((a, b) => a.ordemCampo - b.ordemCampo);
            setDadosFormularioEditar(data);
          } else {
            console.log("---- error");
            console.log(response);
            enqueueSnackbar(
              "Erro ao editar Formulário - Formulário não encontrado",
              { variant: "error" }
            );
            history.push("/formularios");
          }
        });
      } catch (e) {
        console.log("---- error");
        console.log(e);
        enqueueSnackbar("Erro ao editar Formulário", { variant: "error" });
      }
    };

    getDadosFormularioEditar(id);
  }, []);

  return (
    <>
      <FormHeader titulo={tituloPagina} />
      <Grid style={{ marginTop: 180, padding: "0 24px" }}>
        <DndProvider backend={HTML5Backend}>
          {dadosFormularioEditar && (
            <ContainerDragAndDrop
              formularioEditar={dadosFormularioEditar}
              history={history}
            />
          )}
        </DndProvider>
      </Grid>
    </>
  );
};

export default EditarFormulario;
